import { motion } from "framer-motion";
import { Users } from "lucide-react";
import DiscordButton from "./DiscordButton";
import { useIsMobile } from "@/hooks/use-mobile";
const Community = () => {
  const isMobile = useIsMobile();
  return <section className="relative min-h-screen bg-racing-dark overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center" style={{
      backgroundImage: `url('${isMobile ? '/lovable-uploads/FRRM-Website-Paralax-06-Mobile.webp' : '/lovable-uploads/FRRM-Website-Paralax-06.webp'}')`
    }} />

      {/* Background Effects */}
      <div className="absolute inset-0 bg-racing-orange/5 bg-grid-white/[0.02] -z-10" />
      <div className="absolute inset-0 bg-gradient-to-b from-racing-dark via-transparent to-racing-dark -z-10" />
      
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 opacity-20 bg-gradient-to-r from-racing-orange/20 via-transparent to-racing-orange/20 animate-pulse" />

      <div className="h-screen relative">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 h-full relative">
          {/* Left Content */}
          <div className="flex items-start md:items-center px-4 py-[50px]">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} className="space-y-4 md:space-y-8 text-left max-w-xl">
              <h3 className="md:text-2xl lg:text-4xl font-black text-white text-lg">
                JOIN THE <span className="text-racing-orange">FR:RM</span> COMMUNITY 
              </h3>

              <p className="text-white/80 text-base">
              Saddle up and join the FR:RM Community on Discord! Chat with fellow managers aiming for The Winners Circle. Trade prized horses and celebrate your triumphs together. Whether you're chasing glory or just horsing around, this is where champions are made. Don't hold your horses...

              </p>

              <div className="mt-52 md:mt-0">
                <DiscordButton />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};
export default Community;